import type { LayerSpec } from '@/core/pipeline';
import { parseHex, type RGB } from '@/lib/color';

type ThresholdParams = {
  threshold: number; // 0..1
  low: string;
  high: string;
};

export const thresholdSpec: LayerSpec = {
  kind: 'threshold',
  category: 'filter',
  animated: false,
  label: 'Threshold',
  defaults: { threshold: 0.5, low: '#000000', high: '#ffffff' } satisfies ThresholdParams,
  schema: {
    threshold: { type: 'number', label: 'Threshold', min: 0, max: 1, step: 0.01, default: 0.5 },
    low:       { type: 'color',  label: 'Low',  default: '#000000' },
    high:      { type: 'color',  label: 'High', default: '#ffffff' },
  },
  run: (input, params) => {
    if (!input) return new ImageData(1, 1);
    const p = params as ThresholdParams;
    const lo = parseHex(p.low) ?? ([0, 0, 0] as RGB);
    const hi = parseHex(p.high) ?? ([255, 255, 255] as RGB);
    const cut = Math.round(p.threshold * 255);
    const out = new ImageData(input.width, input.height);
    const src = input.data;
    const dst = out.data;
    for (let i = 0; i < src.length; i += 4) {
      const lum =
        0.2126 * (src[i] as number) +
        0.7152 * (src[i + 1] as number) +
        0.0722 * (src[i + 2] as number);
      const c = lum >= cut ? hi : lo;
      dst[i] = c[0]; dst[i + 1] = c[1]; dst[i + 2] = c[2];
      dst[i + 3] = src[i + 3] as number;
    }
    return out;
  },
};
